import React from 'react';
import PropTypes from 'prop-types';
import { ModelPropType } from '../ModelPropTypes';

const CustomComponent = ({ model, value, onChange }) => {
  return (
    <>
      { model?.properties?.render(value, onChange, model?.properties) || null }
    </>
  );
};

CustomComponent.propTypes = {
  model: ModelPropType,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default React.memo(CustomComponent);
